import SidebarTemplate from "components/templates/SidebarTemplate";
import React from "react";
import StoreSalesReportManagementLayout from "components/organismos/master/storeManagement/report/StoreSalesReportManagement";

const StoreSalesReportManagementPage = () => (
  <SidebarTemplate pageTitle="店舗別売上管理帳票">
    <StoreSalesReportManagementLayout />
  </SidebarTemplate>
);
export default StoreSalesReportManagementPage;
